import { fetchConfig } from '@theme/utilities';
import { CartAddEvent } from '@theme/events';

if (!window.customElements.get('product-card-size-form')) {
  window.customElements.define('product-card-size-form', class ProductCardSizeForm extends HTMLElement {
    constructor() {
      super();
      this.handleVariantChange = this.handleVariantChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.formId = this.dataset.formId;
      this.form = document.querySelector(`#${this.formId}`);
      this.variantRadios = this.form.querySelectorAll('input[type="radio"]');
      this.hiddenIdInput = this.form.querySelector('input[name="id"]');

      this.variantRadios.forEach(input => input.addEventListener('change', this.handleVariantChange));
      this.form.addEventListener('submit', this.handleSubmit);
    }

    disconnectedCallback() {
      this.variantRadios.forEach(input => input.removeEventListener('change', this.handleVariantChange));
      this.form.removeEventListener('submit', this.handleSubmit);
    }

    handleVariantChange(event) {
      const selectedValue = event.target.value;
      if (this.hiddenIdInput) {
        this.hiddenIdInput.value = selectedValue;
      }

      event.target.closest('label').setAttribute('shimmer', '');

      // Submit the form programmatically on variant change
      this.form.requestSubmit();
    }

    handleSubmit(event) {
      event.preventDefault();

      const formData = new FormData(this.form);

      const cartItemsComponents = document.querySelectorAll('cart-items-component');
      let cartItemComponentsSectionIds = [];
      cartItemsComponents.forEach((item) => {
        if (item instanceof HTMLElement && item.dataset.sectionId) {
          cartItemComponentsSectionIds.push(item.dataset.sectionId);
        }
        formData.append('sections', cartItemComponentsSectionIds.join(','));
      });

      const fetchCfg = fetchConfig('javascript', { body: formData });

      fetch(Theme.routes.cart_add_url, {
        ...fetchCfg,
        headers: {
          ...fetchCfg.headers,
          Accept: 'application/json',
        },
      })
        .then(response => {
          if (!response.ok) {
            return response.json().then(data => {
              throw new Error(data.message || 'Failed to add to cart');
            });
          }
          return response.json();
        })
        .then(data => {
          const id = formData.get('id');    
          this.dispatchEvent(
            new CartAddEvent({}, id.toString(), {
              source: 'product-form-component',
              itemCount: Number(formData.get('quantity')),
              productId: this.dataset.productId,
              sections: data.sections,
            })
          );
        })
        .catch(error => {
          console.error('Add to cart error:', error);
        })
        .finally(() => {
          // Reset all variant radio inputs (unchecked)
          this.variantRadios.forEach(input => {
            input.closest('label').removeAttribute('shimmer');
            input.checked = false;
          })

          // Optionally reset hidden input to empty or default
          if (this.hiddenIdInput) {
            this.hiddenIdInput.value = '';
          }
        });
    }
  });
}